import React from 'react'

const WalletBalance = () => {
    return (
        <div className='border border-snow-100 rounded-midxs py-5 px-6 lg:px-4 xl:px-6 w-full bg-white flex items-center justify-between'>
            <div className='pr-8 lg:pr-2 xl:pr-16 border-r border-snow-100'>
                <div className='flex items-center'>
                    <svg width='31' height='30' viewBox='0 0 31 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                            opacity='0.3'
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M5.08924 4.68204L28.03 10.829C28.6968 11.0077 29.0925 11.6931 28.9139 12.3599L25.6786 24.434C25.4999 25.1008 24.8145 25.4966 24.1477 25.3179L1.20696 19.1709C0.540125 18.9923 0.144397 18.3068 0.323074 17.64L3.55831 5.56593C3.73699 4.8991 4.42241 4.50337 5.08924 4.68204ZM13.3244 19.8296C15.9917 20.5443 18.7334 18.9614 19.4481 16.2941C20.1628 13.6267 18.5799 10.885 15.9126 10.1703C13.2452 9.45563 10.5035 11.0385 9.78884 13.7059C9.07413 16.3732 10.657 19.1149 13.3244 19.8296Z'
                            fill='#52BD95'
                        />
                        <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M2.74414 7.5H26.4941C27.1845 7.5 27.7441 8.05964 27.7441 8.75V21.25C27.7441 21.9404 27.1845 22.5 26.4941 22.5H2.74414C2.05378 22.5 1.49414 21.9404 1.49414 21.25V8.75C1.49414 8.05964 2.05378 7.5 2.74414 7.5ZM14.6191 20C17.3806 20 19.6191 17.7614 19.6191 15C19.6191 12.2386 17.3806 10 14.6191 10C11.8577 10 9.61914 12.2386 9.61914 15C9.61914 17.7614 11.8577 20 14.6191 20ZM14.6191 17.5C15.9999 17.5 17.1191 16.3807 17.1191 15C17.1191 13.6193 15.9999 12.5 14.6191 12.5C13.2384 12.5 12.1191 13.6193 12.1191 15C12.1191 16.3807 13.2384 17.5 14.6191 17.5Z'
                            fill='#52BD95'
                        />
                    </svg>
                    <p className='ml-2 tracking-wide font-medium'>Wallet Balance</p>
                </div>
                <div>
                    <p className='text-3xl font-semibold tracking-wide text-dark'>N20,000</p>
                </div>
            </div>
            <div className='pr-1 lg:pr-0 xl:pr-4'>
                <button className='flex flex-col items-center'>
                    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                            opacity='0.2'
                            d='M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z'
                            fill='#0D1537'
                        />
                        <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M13.75 13.75V8.75C13.75 8.05964 14.3096 7.5 15 7.5C15.6904 7.5 16.25 8.05964 16.25 8.75V13.75H21.25C21.9404 13.75 22.5 14.3096 22.5 15C22.5 15.6904 21.9404 16.25 21.25 16.25H16.25V21.25C16.25 21.9404 15.6904 22.5 15 22.5C14.3096 22.5 13.75 21.9404 13.75 21.25V16.25H8.75C8.05964 16.25 7.5 15.6904 7.5 15C7.5 14.3096 8.05964 13.75 8.75 13.75H13.75Z'
                            fill='#0D1537'
                        />
                    </svg>
                    <p className='tracking-wide text-sm mt-1'>Top up</p>
                </button>
            </div>
        </div>
    )
}

export default WalletBalance
